module.exports = __webpack_public_path__ + "img/img13.3e4314f1.png";